import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import IndiaBoatsTopBar from "../Components/IndiaBoatsTopBar";
import PremiumNavbar from "../Components/PremiumNavbar";

const Terms = () => {
  return (
    <>
    {/* <Header/> */}
    <IndiaBoatsTopBar />
      <PremiumNavbar />
      <>
      {/* Section 1 – Heading + Description */}
      <section className="ib-terms-hero">
        <div className="ib-terms-hero-inner">
          <span className="ib-terms-eyebrow">Website Policy</span>
          <h1 className="ib-terms-title">Terms of Use &amp; Booking Terms</h1>
          <p className="ib-terms-desc">
            The terms that apply when you use indiaboats.in, request a quotation,
            make a booking or participate in an Indiaboats yacht, boat or sailing
            experience.
          </p>
          <div className="ib-terms-meta">
            <span>Last updated: 2 September 2026</span>
            <span>Operated by Aquartia Pvt. Ltd.</span>
          </div>
        </div>
      </section>

      {/* Section 2 – Sidebar + Right Content */}
      <main className="ib-terms-shell">
        {/* Left Sidebar (TOC) */}
        <aside className="ib-terms-toc" aria-label="Policy contents">
          <div className="ib-terms-toc-title">On this page</div>
          <nav className="ib-terms-toc-nav">
            <a href="#acceptance-of-these-terms">1. Acceptance of These Terms</a>
            <a href="#about-indiaboats">2. About Indiaboats</a>
            <a href="#website-information">3. Website Information</a>
            <a href="#enquiries-quotations-and-booking-confirmation">4. Enquiries, Quotations and Booking Confirmation</a>
            <a href="#prices-taxes-and-payments">5. Prices, Taxes and Payments</a>
            <a href="#guest-count-and-capacity">6. Guest Count and Capacity</a>
            <a href="#safety-comes-first">7. Safety Comes First</a>
            <a href="#weather-sea-conditions-and-operational-changes">8. Weather, Sea Conditions and Operational Changes</a>
            <a href="#guest-conduct-and-prohibited-items">9. Guest Conduct and Prohibited Items</a>
            <a href="#food-beverages-swimming-kayaking-and-other-activities">10. Food, Beverages, Swimming, Kayaking and Other Activities</a>
            <a href="#mandwa-alibaug-elephanta-and-curated-packages">11. Mandwa, Alibaug, Elephanta and Curated Packages</a>
            <a href="#corporate-events-and-sailing-regattas">12. Corporate Events and Sailing Regattas</a>
            <a href="#vessel-substitution-and-supplier-changes">13. Vessel Substitution and Supplier Changes</a>
            <a href="#delays-and-late-arrival-by-guests">14. Delays and Late Arrival by Guests</a>
            <a href="#damage-cleaning-and-loss">15. Damage, Cleaning and Loss</a>
            <a href="#personal-belongings">16. Personal Belongings</a>
            <a href="#photography-reviews-and-user-content">17. Photography, Reviews and User Content</a>
            <a href="#intellectual-property">18. Intellectual Property</a>
            <a href="#third-party-services-and-links">19. Third-Party Services and Links</a>
            <a href="#limitation-of-liability">20. Limitation of Liability</a>
            <a href="#force-majeure">21. Force Majeure</a>
            <a href="#privacy">22. Privacy</a>
            <a href="#complaints-and-grievances">23. Complaints and Grievances</a>
            <a href="#governing-law-and-jurisdiction">24. Governing Law and Jurisdiction</a>
            <a href="#changes-to-these-terms">25. Changes to These Terms</a>
          </nav>
        </aside>

        {/* Right Content */}
        <article className="ib-terms-content">
          <div className="ib-terms-intro">
            <strong>Please read these terms before booking.</strong> They are
            designed to make expectations clear around confirmations, payments,
            safety, weather, guest conduct, vessel operations and supplier-led
            services.
          </div>

          <section className="ib-terms-section" id="acceptance-of-these-terms">
            <h2>1. Acceptance of These Terms</h2>
            <p>
              By accessing indiaboats.in, submitting an enquiry, accepting a
              quotation, making a payment or participating in an Indiaboats
              experience, you agree to these Terms of Use &amp; Booking Terms,
              our Privacy Policy, our Refunds &amp; Cancellation Policy and any
              booking-specific conditions communicated to you in writing. If there
              is a conflict, the booking-specific written confirmation will apply
              to that booking to the extent permitted by law.
            </p>
          </section>

          <section className="ib-terms-section" id="about-indiaboats">
            <h2>2. About Indiaboats</h2>
            <p>
              Indiaboats / India Boats provides and coordinates private yacht
              charters, yacht parties, sailing experiences, private speedboat
              transfers, curated coastal packages and corporate experiences in
              Mumbai and Goa. Services are operated by Aquartia Pvt. Ltd. and may
              involve vessels, captains, crew, guides, transport providers,
              caterers, activity providers, jetty/port authorities and other
              third-party suppliers.
            </p>
          </section>

          <section className="ib-terms-section" id="website-information">
            <h2>3. Website Information</h2>
            <p>
              We aim to keep vessel descriptions, photographs, routes,
              capacities, inclusions, schedules and prices accurate. Images may
              be representative, specifications may change, and vessel
              availability is dynamic. Website content is informational until a
              booking is confirmed in writing after payment verification. Nothing
              on the website guarantees that a particular vessel, date, route,
              activity or supplier is available.
            </p>
          </section>

          <section className="ib-terms-section" id="enquiries-quotations-and-booking-confirmation">
            <h2>4. Enquiries, Quotations and Booking Confirmation</h2>
            <p>
              An enquiry, quotation or verbal discussion does not reserve a
              vessel or time slot.
            </p>
            <ul>
              <li>
                No slot is held until the required payment has been received and
                verified by Indiaboats.
              </li>
            </ul>
            <p>
              Before payment, you should review the consolidated booking details,
              including date, time, guest count, vessel/experience, route, price,
              taxes and key inclusions.
            </p>
            <ul>
              <li>
                A booking is confirmed only when Indiaboats issues a written
                confirmation after payment verification.
              </li>
            </ul>
            <p>
              The exact jetty, boarding point and final operational instructions
              may be provided in the final confirmation for operational and
              security reasons.
            </p>
            <p>
              For yacht charters, guests should normally report approximately 20
              minutes before the confirmed departure time unless the booking
              confirmation states otherwise.
            </p>
          </section>

          <section className="ib-terms-section" id="prices-taxes-and-payments">
            <h2>5. Prices, Taxes and Payments</h2>
            <p>
              Prices are quoted for the specific experience and booking details
              supplied to us. Unless expressly stated otherwise, applicable GST,
              statutory charges, entry tickets, permits, waiting charges,
              transport, catering, décor, activities or other third-party costs
              may be additional. Payment terms, instalments and due dates will be
              stated in the quotation or booking confirmation.
            </p>
            <p>
              Speedboats are generally booked as private full-boat charters
              rather than on a per-person ticket basis. Any route-specific
              waiting charge, entry fee or exclusion will be disclosed in the
              applicable quotation or booking information.
            </p>
          </section>

          <section className="ib-terms-section" id="guest-count-and-capacity">
            <h2>6. Guest Count and Capacity</h2>
            <p>
              The confirmed guest count must not exceed the lawful or operational
              capacity of the vessel or the guest limit stated in the booking.
              Indiaboats may refuse boarding to additional guests where capacity,
              safety, permissions or operating rules would be exceeded. No refund
              is due for guests who do not attend or who cannot be accommodated
              because the booked limit is exceeded.
            </p>
          </section>

          <section className="ib-terms-section" id="safety-comes-first">
            <h2>7. Safety Comes First</h2>
            <p>
              Safety and customer experience are top Indiaboats priorities.
              Marine activities involve inherent risks and no sea journey can be
              represented as completely risk-free. Guests must follow all safety
              briefings, wear life jackets when instructed, use the vessel
              responsibly and comply promptly with directions from the captain
              and crew.
            </p>
            <p>
              The captain’s decision is final on matters of navigation, safety,
              passenger conduct, route, speed, anchoring, activity approval,
              departure, return or termination of an experience. This includes
              decisions arising from weather, tide, sea state, visibility,
              harbour restrictions, mechanical concerns or other operational
              conditions.
            </p>
          </section>

          <section className="ib-terms-section" id="weather-sea-conditions-and-operational-changes">
            <h2>8. Weather, Sea Conditions and Operational Changes</h2>
            <p>
              Weather forecasts or rain alone do not automatically cancel a
              booking. Only Indiaboats, the captain, vessel operator or other
              authorised personnel may determine that conditions are unsafe or
              that the trip should be delayed, altered, rescheduled or cancelled.
              Routes, timings, anchorages and activities may change because of
              weather, tide, sea conditions, permissions, harbour control, safety
              requirements or other circumstances beyond reasonable control.
            </p>
            <p>
              Where an operational change or cancellation occurs, the remedy will
              be handled in accordance with the Refunds &amp; Cancellation
              Policy, booking-specific conditions, supplier commitments and
              applicable law.
            </p>
          </section>

          <section className="ib-terms-section" id="guest-conduct-and-prohibited-items">
            <h2>9. Guest Conduct and Prohibited Items</h2>
            <p>
              Guests must behave responsibly and must not endanger themselves,
              the crew, other guests, the vessel, marine life or property. Unless
              specifically approved in writing and lawful for the relevant
              vessel/event, the following are prohibited:
            </p>
            <ul>
              <li>Illegal drugs or controlled substances.</li>
            </ul>
            <p>
              Violence, harassment, threatening behaviour or uncontrolled
              misconduct.
            </p>
            <p>
              Unsafe movement, climbing, jumping, diving or swimming contrary to
              crew instructions.
            </p>
            <p>
              Fireworks, open flames, flammable devices or unsafe pyrotechnics.
            </p>
            <ul>
              <li>
                Confetti or materials that may pollute the sea or damage the
                vessel.
              </li>
            </ul>
            <p>
              Nails, screws, permanent adhesives or décor that can damage the
              vessel.
            </p>
            <ul>
              <li>
                Smoking or vaping onboard unless a specific designated area is
                expressly approved by the captain/operator.
              </li>
            </ul>
            <p>
              Any item or activity prohibited by law, port/harbour rules, the
              vessel operator or the captain.
            </p>
            <p>
              Indiaboats or the captain may refuse boarding, stop an activity or
              terminate a trip where guest behaviour presents a safety, legal or
              property risk. In such cases, refund eligibility may be reduced or
              excluded in accordance with the Refunds &amp; Cancellation Policy
              and applicable law.
            </p>
          </section>

          <section className="ib-terms-section" id="food-beverages-swimming-kayaking-and-other-activities">
            <h2>10. Food, Beverages, Swimming, Kayaking and Other Activities</h2>
            <p>
              Food, beverages, music, kayaking, swimming, décor, entertainment or
              other activities are included only where expressly stated in the
              package or booking confirmation. All water activities are subject
              to weather, sea conditions, permissions, equipment availability and
              the captain’s or authorised operator’s safety clearance. Guests
              must follow all activity instructions. Alcohol, where offered or
              permitted, is subject to applicable law, vessel rules and
              responsible consumption requirements.
            </p>
          </section>

          <section className="ib-terms-section" id="mandwa-alibaug-elephanta-and-curated-packages">
            <h2>11. Mandwa, Alibaug, Elephanta and Curated Packages</h2>
            <p>
              Destination and curated packages may combine marine transport with
              local transport, guides, permissions, sightseeing, meals,
              activities or overnight arrangements. Timings are indicative unless
              expressly guaranteed in writing and may vary because of sea, road,
              harbour, tide, queue, authority or supplier conditions. Third-party
              inclusions are subject to supplier availability and their operating
              rules.
            </p>
            <p>
              For speedboat transfers to Mandwa or Elephanta, route-specific
              details such as jetty, waiting period, local entry charges and
              exclusions will be shown in the quotation or booking confirmation.
              Elephanta monument/entry charges are not included unless expressly
              stated. For Mandwa transfers, any complimentary waiting period and
              additional waiting charges will be specified in the booking terms
              applicable at the time.
            </p>
          </section>

          <section className="ib-terms-section" id="corporate-events-and-sailing-regattas">
            <h2>12. Corporate Events and Sailing Regattas</h2>
            <p>
              Corporate events, sailing regattas, awards, networking events and
              large yacht parties require additional planning and may involve
              event suppliers, branding, permissions, catering, entertainment and
              multiple vessels. Event-specific terms, minimum guest numbers,
              payment schedules, supplier commitments and cancellation charges
              may apply. Corporate sailing regattas are currently offered in
              Mumbai and may require a minimum group size stated in the
              quotation.
            </p>
          </section>

          <section className="ib-terms-section" id="vessel-substitution-and-supplier-changes">
            <h2>13. Vessel Substitution and Supplier Changes</h2>
            <p>
              Where a confirmed vessel or supplier becomes unavailable because of
              technical, safety, regulatory or other operational reasons,
              Indiaboats may offer a reasonably comparable substitute, reschedule
              the service or provide another remedy permitted under the booking
              terms and applicable law. We will not knowingly downgrade a
              confirmed paid service without informing you and addressing any
              material difference appropriately.
            </p>
          </section>

          <section className="ib-terms-section" id="delays-and-late-arrival-by-guests">
            <h2>14. Delays and Late Arrival by Guests</h2>
            <p>
              Marine operations are time-sensitive. If guests arrive late, the
              charter may still end at the originally scheduled time because of
              harbour windows, subsequent bookings, crew duty, tide or
              operational restrictions. Any extension is subject to vessel
              availability, safety clearance and additional charges. A no-show or
              guest-caused missed departure will be treated under the Refunds
              &amp; Cancellation Policy.
            </p>
          </section>

          <section className="ib-terms-section" id="damage-cleaning-and-loss">
            <h2>15. Damage, Cleaning and Loss</h2>
            <p>
              The booking party is responsible for damage, extraordinary cleaning
              or loss caused by guests through misuse, negligence, prohibited
              décor, unsafe behaviour or violation of crew instructions. Charges
              may be raised after assessment by the captain, vessel operator or
              Indiaboats and may include repair, replacement, cleaning, supplier
              or downtime costs reasonably attributable to the incident.
            </p>
          </section>

          <section className="ib-terms-section" id="personal-belongings">
            <h2>16. Personal Belongings</h2>
            <p>
              Guests are responsible for their own phones, cameras, jewellery,
              bags and other personal belongings. Indiaboats is not responsible
              for loss or damage except to the extent caused by our negligence or
              where liability cannot lawfully be excluded.
            </p>
          </section>

          <section className="ib-terms-section" id="photography-reviews-and-user-content">
            <h2>17. Photography, Reviews and User Content</h2>
            <p>
              You retain rights in photographs, reviews or other content you
              create. If you send us content for publication, tag us for
              reposting, or separately consent to promotional use, you grant
              Indiaboats a non-exclusive permission to use that content for the
              agreed marketing purpose. We will not treat attendance at a booking
              alone as blanket consent to use identifiable images for
              advertising.
            </p>
          </section>

          <section className="ib-terms-section" id="intellectual-property">
            <h2>18. Intellectual Property</h2>
            <p>
              The Indiaboats name, logos, website text, design, photographs,
              graphics and other content owned or licensed by us are protected by
              applicable intellectual-property laws. You may use the website for
              personal and legitimate business-enquiry purposes but may not copy,
              republish, scrape, sell, impersonate, misuse or commercially
              exploit our content without permission.
            </p>
          </section>

          <section className="ib-terms-section" id="third-party-services-and-links">
            <h2>19. Third-Party Services and Links</h2>
            <p>
              Some bookings include or link to services provided by independent
              third parties. Indiaboats will use reasonable care in selecting and
              coordinating suppliers, but third-party services may also be
              subject to the supplier’s own terms, availability and legal
              obligations. Nothing in these Terms removes rights or remedies that
              cannot lawfully be excluded under consumer law.
            </p>
          </section>

          <section className="ib-terms-section" id="limitation-of-liability">
            <h2>20. Limitation of Liability</h2>
            <p>
              To the fullest extent permitted by law, Indiaboats will not be
              liable for indirect, special or consequential loss arising from use
              of the website or a booking, or for events outside our reasonable
              control. Any limitation applies only to the extent lawful and does
              not exclude liability or consumer rights that cannot legally be
              excluded, restricted or waived. Nothing in these Terms is intended
              to excuse deficient service, misleading representations, fraud,
              wilful misconduct or other liability that applicable law does not
              permit us to exclude.
            </p>
          </section>

          <section className="ib-terms-section" id="force-majeure">
            <h2>21. Force Majeure</h2>
            <p>
              We are not responsible for failure or delay caused by events beyond
              reasonable control, including severe weather or sea conditions,
              harbour closure, government or port restrictions, natural disaster,
              civil disturbance, epidemic/pandemic restrictions, strikes,
              navigation restrictions, emergency incidents or comparable events.
              We will act reasonably to communicate material changes and offer
              the remedy available under the booking terms, Refunds &amp;
              Cancellation Policy and applicable law.
            </p>
          </section>

          <section className="ib-terms-section" id="privacy">
            <h2>22. Privacy</h2>
            <p>
              Personal data is handled in accordance with the Indiaboats Privacy
              Policy, which forms part of these Terms.
            </p>
          </section>

          <section className="ib-terms-section" id="complaints-and-grievances">
            <h2>23. Complaints and Grievances</h2>
            <ul>
              <li>
                Please raise any booking or service concern promptly so that we
                have a fair opportunity to investigate it.
              </li>
            </ul>
            <p>
              <strong>Email:</strong> customercare@indiaboats.in
            </p>
            <p>
              <strong>Customer Care:</strong> +91 85919 93301 / +91 90040 13301 /
              +91 85919 83301 / 022 6695 8111
            </p>
            <p>
              <strong>Registered Office:</strong> 803, Hubtown VIVA, Western
              Express Highway, Shankerwadi, Jogeshwari East, Mumbai – 400060,
              Maharashtra, India
            </p>
            <ul>
              <li>
                We will handle grievances in accordance with applicable law and
                our internal process.
              </li>
            </ul>
          </section>

          <section className="ib-terms-section" id="governing-law-and-jurisdiction">
            <h2>24. Governing Law and Jurisdiction</h2>
            <p>
              These Terms are governed by the laws of India. All disputes, claims
              and proceedings arising out of or relating to the website, any
              quotation, booking, payment, service or experience with Indiaboats
              shall be subject to the exclusive jurisdiction of the competent
              courts at Mumbai, Maharashtra, India, subject to any mandatory
              rights available to consumers under applicable law.
            </p>
          </section>

          <section className="ib-terms-section" id="changes-to-these-terms">
            <h2>25. Changes to These Terms</h2>
            <p>
              We may update these Terms from time to time. The version in force
              when your booking is confirmed will generally apply to that
              booking, together with any booking-specific written terms. Updated
              website terms will apply to subsequent use and bookings from their
              effective date.
            </p>
          </section>

          
          {/* Policy Links – Pill Buttons */}
<div className="ib-privacy-links">
  <a href="/privacy" className="ib-privacy-link">Privacy Policy</a>
  <a href="/terms" className="ib-privacy-link">Terms of Use</a>
  <a href="/refund" className="ib-privacy-link">Refund Policy</a>
  <a href="/contact" className="ib-privacy-link">Contact Indiaboats</a>
</div>  
        </article>
      </main>
    </>




      <Footer/>
    </>
  );
};

export default Terms;
